import DnaHub from 'components/DnaHub/DnaHub';

const App = (): JSX.Element => <DnaHub />;

export default App;
